import { createContext } from "react";

export interface LightboxContextParams {
  openWithLightbox: Function;
}

export const LightboxContext = createContext<LightboxContextParams>({
  openWithLightbox: () => {},
});
